import { Modal } from 'antd';
import exampleImg from '../img/grouped-checklist.jpg';

const GroupedProductsNoticeModal = ({
    open,
    onClose,
    orderIndexes = [],
    canClose,
    countdown,
}) => {
    const indexesText = orderIndexes.join(', ');

    return (
        <Modal
            title="ВНИМАНИЕ!"
            open={open}
            onCancel={onClose}
            maskClosable={canClose}
            keyboard={canClose}
            closable={canClose}
            centered
            width={650}
            footer={[
                <button
                    key="close"
                    type="button"
                    className="grouped-products-modal-close"
                    onClick={onClose}
                    disabled={!canClose}
                >
                    {canClose ? 'Закрыть' : `Закрыть (${countdown} сек)`}
                </button>,
            ]}
        >
            <div className="grouped-products-modal-content">
                <div className="grouped-products-modal-left">
                    <p style={{ marginTop: '32px' }}>
                        В заказах где более 5 одинаковых товаров сейчас на чек-листах такие товары
                        группируются. Количество товаров заказанных указывается в черном квадратике.
                        Пожалуйста, не пропустите эту информацию и соберите заказы корректно!
                    </p>

                    <p style={{ marginTop: '48px' }}>
                        В ваших чек-листах обратите внимание на номера: <b>{indexesText}</b>
                    </p>
                </div>

                <div className="grouped-products-modal-right">
                    <img
                        src={exampleImg}
                        alt="Пример группировки на чек-листе"
                        className="grouped-products-modal-image"
                    />
                </div>
            </div>
        </Modal>
    );
};

export default GroupedProductsNoticeModal;
